import './App.css';
import Header from "./components/MyHeader.js";
import Hero from './components/Hero';
import About from './components/About';
import Events from './components/Events';
import News from './components/News';
import Blog from './components/Blog';
import Footer from './components/Footer';

function App() {
  return (
      <>
        <a className="skip-link" href="#main-content">Skip to main content</a>
        <Header />
        <main id="main-content">
          <Hero />
          <About />
          <Events />
          <News />
          <Blog />
        </main>
        <Footer />
      </>
  );
}

export default App;
